// import React, { useState } from "react";
// import { useSelector } from "react-redux";
// import useApi from "../../../CustomHooks/useApi";

// const P2PWalletTransfer = () => {
//     const mid = useSelector(
//         (s) => s.auth.employeeDetails?.username
//     );

//     const { callApi: p2pSearch } = useApi("/p2p/search", "GET");
//     const { callApi: walletTransfer } = useApi("/p2p/wallet-transfer", "POST");

//     const [mobile, setMobile] = useState("");
//     const [amount, setAmount] = useState("");
//     const [remarks, setRemarks] = useState("");
//     const [receiverData, setReceiverData] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [message, setMessage] = useState(null);

//     /* ================= SEARCH ================= */
//     const handleSearch = async () => {
//         setMessage(null);

//         if (!mobile) {
//             setMessage({ type: "error", text: "Please enter mobile number" });
//             return;
//         }

//         try {
//             setLoading(true);
//             const res = await p2pSearch(null, `?mobile=${mobile}`);
//             setReceiverData(res);
//             setMessage({ type: "success", text: "User found successfully" });
//         } catch (err) {
//             setReceiverData(null);
//             setMessage({ type: "error", text: "User not found" });
//         } finally {
//             setLoading(false);
//         }
//     };

//     /* ================= TRANSFER ================= */
//     const handleTransfer = async () => {
//         setMessage(null);

//         if (!amount || Number(amount) <= 0) {
//             setMessage({ type: "error", text: "Enter valid amount" });
//             return;
//         }

//         try {
//             setLoading(true);

//             const payload = {
//                 senderMid: mid,
//                 receiverMobile: mobile,
//                 amount: Number(amount),
//                 remarks: remarks || "Wallet to Wallet Transfer",
//                 walletType: "MRCHNT",
//             };

//             const res = await walletTransfer(payload);

//             if (res?.status?.toUpperCase() === "SUCCESS") {
//                 setMessage({
//                     type: "success",
//                     text: `Transaction ID: ${res.txnId}
// ${res.message}

// Sender Balance: ₹${res.senderBalance}
// Receiver Balance: ₹${res.receiverBalance}`,
//                 });

//                 // Auto clear after 4 seconds
//                 setTimeout(() => {
//                     setMobile("");
//                     setAmount("");
//                     setRemarks("");
//                     setReceiverData(null);
//                     setMessage(null);
//                 }, 4000);

//             } else {
//                 setMessage({
//                     type: "error",
//                     text: res?.message || "Transfer failed",
//                 });
//             }
//         } catch (err) {
//             setMessage({
//                 type: "error",
//                 text:
//                     err?.response?.data?.message ||
//                     "Transfer failed. Try again.",
//             });
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <div className="min-h-screen bg-white px-4 md:px-6 py-6">
//             <div className="max-w-4xl mx-auto">
//                 <div className="bg-white rounded-3xl shadow-xl border border-gray-100 p-6 md:p-10 space-y-8">

//                     {/* Title */}
//                     <div className="text-center">
//                         <h1 className="text-3xl md:text-2xl font-bold text-gray-900">
//                             P2P Wallet Transfer
//                         </h1>
//                         <p className="text-base text-gray-500 mt-2">
//                             Transfer money instantly using mobile number
//                         </p>
//                     </div>

//                     {/* Mobile Input */}
//                     <div>
//                         <label className="block text-base font-semibold text-gray-700 mb-3">
//                             Receiver Mobile Number
//                         </label>

//                         <div className="flex flex-col md:flex-row gap-4">
//                             <input
//                                 type="text"
//                                 value={mobile}
//                                 onChange={(e) => setMobile(e.target.value)}
//                                 placeholder="Enter mobile number"
//                                 className="w-full border-2 border-gray-200 rounded-3xl px-6 py-5 text-xl font-medium focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition"
//                             />

//                             <button
//                                 onClick={handleSearch}
//                                 disabled={loading}
//                                 className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-5 rounded-3xl text-lg font-bold transition disabled:opacity-50 shadow-md"
//                             >
//                                 {loading ? "Searching..." : "Search"}
//                             </button>
//                         </div>
//                     </div>

//                     {/* Receiver Info */}
//                     {receiverData && (
//                         <div className="bg-green-50 border border-green-200 rounded-3xl p-6 space-y-4">
//                             <div className="text-green-700 font-semibold text-lg text-center">
//                                 Receiver Verified ✓
//                             </div>

//                             <div className="grid md:grid-cols-3 gap-4 text-center md:text-left">
//                                 <div>
//                                     <p className="text-sm text-gray-500">Shop Name</p>
//                                     <p className="text-lg font-semibold text-gray-800">
//                                         {receiverData.shopName}
//                                     </p>
//                                 </div>

//                                 <div>
//                                     <p className="text-sm text-gray-500">Mobile</p>
//                                     <p className="text-lg font-semibold text-gray-800">
//                                         {receiverData.mobile}
//                                     </p>
//                                 </div>

//                                 <div>
//                                     <p className="text-sm text-gray-500">Role</p>
//                                     <p className="text-lg font-semibold text-gray-800">
//                                         {receiverData.role}
//                                     </p>
//                                 </div>
//                             </div>
//                         </div>
//                     )}

//                     {/* Amount */}
//                     {receiverData && (
//                         <div>
//                             <label className="block text-base font-semibold text-gray-700 mb-3">
//                                 Enter Amount
//                             </label>

//                             <input
//                                 type="text"
//                                 inputMode="decimal"
//                                 placeholder="0.00"
//                                 value={amount}
//                                 onChange={(e) => {
//                                     const value = e.target.value;
//                                     if (/^\d*\.?\d*$/.test(value)) {
//                                         setAmount(value);
//                                     }
//                                 }}
//                                 className="w-full border-2 border-gray-200 rounded-3xl px-6 py-6 text-2xl font-bold focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition"
//                             />
//                         </div>
//                     )}

//                     {/* Remarks */}
//                     {receiverData && (
//                         <div>
//                             <label className="block text-base font-semibold text-gray-700 mb-3">
//                                 Remarks (Optional)
//                             </label>

//                             <input
//                                 type="text"
//                                 value={remarks}
//                                 onChange={(e) => setRemarks(e.target.value)}
//                                 placeholder="Enter remarks"
//                                 className="w-full border-2 border-gray-200 rounded-3xl px-6 py-5 text-lg font-medium focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition"
//                             />
//                         </div>
//                     )}

//                     {/* Transfer Button */}
//                     {receiverData && (
//                         <button
//                             onClick={handleTransfer}
//                             disabled={loading}
//                             className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-6 rounded-3xl text-xl font-bold transition disabled:opacity-50 shadow-lg"
//                         >
//                             {loading ? "Processing..." : "Transfer Now"}
//                         </button>
//                     )}

//                     {/* Message */}
//                     {message && (
//                         <div
//                             className={`p-5 rounded-3xl text-base font-medium text-center whitespace-pre-line ${
//                                 message.type === "success"
//                                     ? "bg-green-100 text-green-700"
//                                     : "bg-red-100 text-red-700"
//                             }`}
//                         >
//                             {message.text}
//                         </div>
//                     )}

//                 </div>
//             </div>
//         </div>
//     );
// };

// export default P2PWalletTransfer;


import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import useApi from "../../../CustomHooks/useApi";
import { fetchWalletBalance, fetchSettlementBalance, fetchAepsBalance } from "../../../Store/Slices/WalletSlice";

const P2PWalletTransfer = () => {
    const mid = useSelector(
        (s) => s.auth.employeeDetails?.username
    );

    const dispatch = useDispatch();

    const { callApi: p2pSearch } = useApi("/p2p/search", "GET");
    const { callApi: walletTransfer } = useApi("/p2p/wallet-transfer", "POST");

    const [mobile, setMobile] = useState("");
    const [amount, setAmount] = useState("");
    const [remarks, setRemarks] = useState("");
    const [receiverData, setReceiverData] = useState(null);
    const [loading, setLoading] = useState(false);

    // ✅ Only for transfer popup
    const [popup, setPopup] = useState(null);
    const [otpModal, setOtpModal] = useState({ show: false, otp: "", pendingPayload: null });

    /* ================= SEARCH ================= */
    const handleSearch = async () => {
        if (!mobile) {
            // ❌ Popup nahi, simple alert ya ignore
            alert("Please enter mobile number");
            return;
        }

        try {
            setLoading(true);
            const res = await p2pSearch(null, `?mobile=${mobile}`);
            setReceiverData(res); // ✅ Only show details
        } catch (err) {
            setReceiverData(null);
            alert("User not found"); // ❌ popup nahi
        } finally {
            setLoading(false);
        }
    };

    /* ================= TRANSFER ================= */
    const handleTransfer = async () => {
        if (!amount || Number(amount) <= 0) {
            setPopup({ type: "error", text: "Enter valid amount" });
            return;
        }

        const payload = {
            senderMid: mid,
            receiverMobile: mobile,
            amount: Number(amount),
            remarks: remarks || "Wallet to Wallet Transfer",
            walletType: "MRCHNT",
        };

        try {
            setLoading(true);

            const res = await walletTransfer(payload);

            if (res?.status?.toUpperCase() === "SUCCESS") {
                dispatch(fetchWalletBalance());
                dispatch(fetchAepsBalance());
                dispatch(fetchSettlementBalance());
                setPopup({
                    type: "success",
                    text: `Transaction ID: ${res.txnId}
${res.message}

Sender Balance: ₹${res.senderBalance}
Receiver Balance: ₹${res.receiverBalance}`,
                });
            } else {
                setPopup({ type: "error", text: res?.message || "Transfer failed" });
            }

        } catch (err) {
            const isOtpRequired =
                err?.response?.status === 400 &&
                (err?.response?.data?.error_code === "OTP_REQUIRED" ||
                 (err?.response?.data?.message || "").toLowerCase().includes("otp"));

            if (isOtpRequired) {
                setOtpModal({ show: true, otp: "", pendingPayload: payload });
            } else {
                setPopup({
                    type: "error",
                    text: err?.response?.data?.message || "Transfer failed. Try again.",
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleOtpConfirm = async () => {
        if (!otpModal.otp.trim()) return;

        try {
            setLoading(true);

            const res = await walletTransfer({ ...otpModal.pendingPayload, otp: otpModal.otp });
            setOtpModal({ show: false, otp: "", pendingPayload: null });

            if (res?.status?.toUpperCase() === "SUCCESS") {
                dispatch(fetchWalletBalance());
                dispatch(fetchAepsBalance());
                dispatch(fetchSettlementBalance());
                setPopup({
                    type: "success",
                    text: `Transaction ID: ${res.txnId}
${res.message}

Sender Balance: ₹${res.senderBalance}
Receiver Balance: ₹${res.receiverBalance}`,
                });
            } else {
                setPopup({ type: "error", text: res?.message || "Transfer failed" });
            }
        } catch (err) {
            setOtpModal({ show: false, otp: "", pendingPayload: null });
            setPopup({
                type: "error",
                text: err?.response?.data?.message || "OTP verification failed. Try again.",
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-white px-4 md:px-6 py-6">
            <div className="max-w-4xl mx-auto">
                <div className="bg-white rounded-3xl shadow-xl border border-gray-100 p-6 md:p-10 space-y-8">

                    {/* Title */}
                    <div className="text-center">
                        <h1 className="text-3xl md:text-2xl font-bold text-gray-900">
                            P2P Wallet Transfer
                        </h1>
                        <p className="text-base text-gray-500 mt-2">
                            Transfer money instantly using mobile number
                        </p>
                    </div>

                    {/* Mobile Input */}
                    <div>
                        <label className="block text-base font-semibold text-gray-700 mb-3">
                            Receiver Mobile Number
                        </label>

                        <div className="flex flex-col md:flex-row gap-4">
                            <input
                                type="text"
                                value={mobile}
                                onChange={(e) => setMobile(e.target.value)}
                                placeholder="Enter mobile number"
                                className="w-full border-2 border-gray-200 rounded-3xl px-6 py-5 text-xl font-medium focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none transition"
                            />

                            <button
                                onClick={handleSearch}
                                disabled={loading}
                                className="bg-indigo-600 hover:bg-indigo-700 text-white px-8 py-5 rounded-3xl text-lg font-bold transition disabled:opacity-50 shadow-md"
                            >
                                {loading ? "Searching..." : "Search"}
                            </button>
                        </div>
                    </div>

                    {/* Receiver Info */}
                    {receiverData && (
                        <div className="bg-green-50 border border-green-200 rounded-3xl p-6 space-y-4">
                            <div className="text-green-700 font-semibold text-lg text-center">
                                Receiver Verified ✓
                            </div>

                            <div className="grid md:grid-cols-3 gap-4 text-center md:text-left">
                                <div>
                                    <p className="text-sm text-gray-500">Shop Name</p>
                                    <p className="text-lg font-semibold text-gray-800">
                                        {receiverData.shopName}
                                    </p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-500">Mobile</p>
                                    <p className="text-lg font-semibold text-gray-800">
                                        {receiverData.mobile}
                                    </p>
                                </div>

                                <div>
                                    <p className="text-sm text-gray-500">Role</p>
                                    <p className="text-lg font-semibold text-gray-800">
                                        {receiverData.role}
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Amount */}
                    {receiverData && (
                        <div>
                            <label className="block text-base font-semibold text-gray-700 mb-3">
                                Enter Amount
                            </label>

                            <input
                                type="text"
                                value={amount}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    if (/^\d*\.?\d*$/.test(value)) {
                                        setAmount(value);
                                    }
                                }}
                                className="w-full border-2 border-gray-200 rounded-3xl px-6 py-6 text-2xl font-bold"
                            />
                        </div>
                    )}

                    {/* Remarks */}
                    {receiverData && (
                        <div>
                            <label className="block text-base font-semibold text-gray-700 mb-3">
                                Remarks (Optional)
                            </label>

                            <input
                                type="text"
                                value={remarks}
                                onChange={(e) => setRemarks(e.target.value)}
                                className="w-full border-2 border-gray-200 rounded-3xl px-6 py-5 text-lg"
                            />
                        </div>
                    )}

                    {/* Transfer Button */}
                    {receiverData && (
                        <button
                            onClick={handleTransfer}
                            disabled={loading}
                            className="w-full bg-indigo-600 text-white py-6 rounded-3xl text-xl font-bold"
                        >
                            {loading ? "Processing..." : "Transfer Now"}
                        </button>
                    )}

                </div>
            </div>

            {/* ✅ POPUP ONLY FOR TRANSFER */}
            {popup && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                    <div className="bg-white rounded-3xl p-8 w-[90%] max-w-md text-center shadow-2xl">

                        <h2 className={`text-2xl font-bold mb-4 ${popup.type === "success" ? "text-green-600" : "text-red-600"
                            }`}>
                            {popup.type === "success" ? "Success" : "Error"}
                        </h2>

                        <p className="text-gray-700 whitespace-pre-line mb-6">
                            {popup.text}
                        </p>

                        <button
                            onClick={() => {
                                setPopup(null);
                                setMobile("");
                                setAmount("");
                                setRemarks("");
                                setReceiverData(null);
                            }}
                            className="bg-indigo-600 text-white px-6 py-3 rounded-xl font-semibold"
                        >
                            OK
                        </button>
                    </div>
                </div>
            )}

            {otpModal.show && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[200] px-4">
                    <div className="bg-white rounded-3xl p-8 w-full max-w-sm shadow-2xl space-y-5">
                        <h2 className="text-xl font-bold text-gray-800 text-center">OTP Verification</h2>
                        <p className="text-sm text-gray-500 text-center">
                            An OTP has been sent to your registered mobile number. Enter it below to confirm the transfer.
                        </p>
                        <input
                            type="text"
                            inputMode="numeric"
                            maxLength={6}
                            placeholder="Enter OTP"
                            value={otpModal.otp}
                            onChange={(e) => setOtpModal((prev) => ({ ...prev, otp: e.target.value.replace(/\D/g, "") }))}
                            className="w-full border-2 border-gray-200 rounded-2xl px-5 py-4 text-xl font-bold text-center tracking-widest focus:ring-2 focus:ring-indigo-400 focus:border-indigo-400 outline-none"
                        />
                        <div className="flex gap-3">
                            <button
                                onClick={() => setOtpModal({ show: false, otp: "", pendingPayload: null })}
                                className="flex-1 border-2 border-gray-300 text-gray-600 py-3 rounded-2xl font-semibold"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleOtpConfirm}
                                disabled={!otpModal.otp.trim() || loading}
                                className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white py-3 rounded-2xl font-semibold disabled:opacity-50"
                            >
                                {loading ? "Verifying..." : "Confirm"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default P2PWalletTransfer;